<template>
  <div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div style="font-size: 18px;">油站停靠次数top100企业</div>
      <el-form :inline="true" :model="conditon" style="margin-top:20px; ">
        <el-form-item label="统计月份">
          <el-date-picker style="width: 150px;" v-model="conditon.time" type="month" placeholder="选择月" format="yyyy年MM月" value-format="yyyy-MM" @change="onChangeTime"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px;">
          <el-button @click="onPrev">返回上一级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" :max-height="tableHeight + 50" stripe style="width: 100%">
      <el-table-column type="index" width="50" align="center" label="序号"></el-table-column>
      <el-table-column property="companyName" minWidth="180" label="停靠企业名称" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.realCompanyName">{{ scope.row.realCompanyName }}</span>
          <el-tooltip v-else placement="top" content="点击解密">
            <span style="cursor: pointer" @click="onDecrypt(scope.row.id, scope.$index)">{{
                scope.row.companyName
              }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column property="companyAddress" minWidth="200" label="地址" align="center"></el-table-column>
      <el-table-column property="stopCount" label="停靠次数" align="center">
        <template slot-scope="scope">
          {{format(scope.row.stopCount)}}
        </template>
      </el-table-column>
      <el-table-column property="stopCarCount" label="停靠车辆数" align="center">
        <template slot-scope="scope">
          {{format(scope.row.stopCarCount)}}
        </template>
      </el-table-column>
      <el-table-column property="companyCarNumLevel" label="企业旗下总车辆数" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import moment from 'moment'

export default {
  props: {
    id: {
      type: [Number, String],
    },
    dimObj: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      conditon: {
        time: this.dimObj.year + '-' + this.dimObj.month
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    getData() {
      this.tableData = []
      http
        .getStopDetailTop100Company({
          //   poiId: 11116940 || this.id,
          poiId: this.id,
          year: this.conditon.time
            ? this.conditon.time.split('-')[0]
            : moment().year(),
          month: this.conditon.time
            ? this.conditon.time.split('-')[1]
            : moment().format('MM'),
        })
        .then((e) => {
          if (e.code == 200) {
            this.tableData = e.data || []
          } else {
            this.tableData = []
          }
        })
    },
    onChangeTime() {
      this.getData()
    },
    onDecrypt(id, index) {
      http.getStopDetailTop100CompanyDecrypt({ id }).then((r) => {
        if (r.code == 200) {
          this.$set(
            this.tableData[index],
            'realCompanyName',
            r.data.companyName
          )
        }
      })
    },
    onPrev() {
      this.$emit('on-close')
    },
  },
}
</script>